export default "__VITE_ASSET__CYvgDM2D__"